import Vue from 'vue'
import Element from 'element-ui'
import '../element-variables.scss'
// import  "../assets/theme/index.css";

Vue.use(Element)
